const baseURL = "/v1/Download";

const service = {
  methods: {
    $downloadArquivos(params) {
      return this.$api().get(`${baseURL}`, this.$getParamsObject(params));
    },
    $downloadArquivoPorId(id, params) {
      return this.$api().get(`${baseURL}/${id}`, this.$getParamsObject(params));
    },
  },

};
export default service;